import React from "react";
import TextInput from "./TextInput";

export default function DateInput(props) {
  return <TextInput type="date" {...props} />;
}
